module.exports = __webpack_public_path__ + "media/images/icon-store-4e499203448f902dc2cbebfd7a5156c5.svg";